import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import { DeckUI } from '@seedlang/state';
import ReactTooltip from 'react-tooltip';

const HintBox = styled.div`
  font-size: 13px;
  margin: ${props => props.margin};
  background: ${props => props.backgroundColor || Theme.orange};
  color: ${props => props.textColor || '#FFF'};
  padding: 5px 10px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  border: ${props => props.border || 'none'};
  font-style: ${props => props.italic ? 'italic' : 'normal'};

  i {
    color: ${props => props.textColor || '#FFF'};
    font-size: 17px;
    line-height: 19px;
    margin: 0 5px 0 0;
  }
`;

const TooltipWrapper = styled.div`
  margin: ${props => props.margin};
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 12px;

  i {
    margin-right: 3px;
  }
`;

@observer
class GrammarHint extends React.Component {

  @computed get descriptionText() {
    if (!this.props.description) return null;
    return typeof this.props.description === 'string' ?
      this.props.description :
      this.props.description.description;
  }

  @computed get backgroundColor() {
    if (this.props.backgroundColor) return this.props.backgroundColor;
    if (typeof this.props.description === 'object') return this.props.description.color;
    return undefined;
  }

  @computed get marginValue() {
    return this.props.margin || (DeckUI.layout.minimumHeight ? '10px 0 0 0' : '20px 0 0 0');
  }

  render() {
    const description = this.props.description || this.props.text;
    if (!description || !this.descriptionText) return null;

    if (!DeckUI.layout.minimumHeight) {
      return (
        <HintBox
          margin={this.marginValue}
          backgroundColor={this.backgroundColor}
          textColor={this.props.textColor}
          border={this.props.border}
          italic={this.props.italic}
        >
          {
            !this.props.hideIcon &&
            <i className='fa fa-info-circle' />
          }
          {this.descriptionText}
        </HintBox>
      );
    }

    return (
      <TooltipWrapper
        margin={this.marginValue}
        data-tip
        data-for={this.props.tooltipId || 'grammar-hint'}
      >
        {
          !this.props.hideIcon &&
          <i className='fa fa-info-circle' />
        }
        More Info
        <ReactTooltip
          place='top'
          type='dark'
          effect='solid'
          id={this.props.tooltipId || 'grammar-hint'}
          width='300px'
          class='custom-tooltip'
        >
          <div style={{ width: 150 }}>
            {this.descriptionText}
          </div>
        </ReactTooltip>
      </TooltipWrapper>
    );
  }
}

export default GrammarHint;